import { Col, Row, Spin } from "antd";
import Form, { FormComponentProps } from "antd/lib/form";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { useContext } from "src/ReactTS";
import { useState, SetStateAction, Dispatch } from "react";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { IVendaProps } from "src/services/interfaces/IVendaProps";
import { ServiceContext } from "src/services/provider/Service.provider";
import StandardButton from "src/components/common/StandardButton/StandardButton";
import { ShowNotification } from "src/components/common/ShowNotification/ShowNotification";
import { TradePhaseEnum } from "src/services/interfaces/trade/TradePhaseEnum";
import { needMariagePrenuptialAgreement, needMarriageCertificate, userHaveSpouse } from 'src/util/Validations';
import { DocumentCategoryEnum, DocumentCategoryLabel } from 'src/components/Refatoracao/UploadDocument/DocumentCategoryEnum';
import { validateForm } from 'src/util/helper';
import { TradeEditView } from 'src/components/common/TradeEdit/TradeEditView';

function ContractInfo(props: RouteComponentProps<any> & FormComponentProps & IVendaProps & { setTrade: Dispatch<SetStateAction<ITrade>> }) {
  const { tradeService, documentService } = useContext(ServiceContext);
  const { trade, setTrade } = props;
  const [loading, setLoading] = useState(false);

  async function handleSubmit() {

    if (validateForm(props) && await validateUpdate()) {
      setLoading(true);
      tradeService
        .postUpdateManualTrade(trade, false)
        .then((response) => {
          ShowNotification.Success("Sucesso!", response.message)
          props.onChangePhase(TradePhaseEnum.BankInfo);
        })
        .catch(ex => {
          ShowNotification.Error("Não é possivel atualizar o trade", ex?.response?.data?.message)
        })
        .finally(() => setLoading(false));
    }
  }

  async function validateUpdate() {
    if (userHaveSpouse(trade)) {
      const document = await documentService.getSpouseDocIdByTradeId(trade.id);
      if (!document) {
        ShowNotification.Error("Não é possivel avançar o trade", "Documento do Conjuge é obrigatório");
        return false;
      }
    }

    if (needMarriageCertificate(trade)) {
      const document = await documentService.getDocumentByTradeAndCategory(trade.id, DocumentCategoryEnum.MARRIAGE_CERTIFICATE);

      if (!document) {
        ShowNotification.Error("Não é possivel avançar o trade", `${DocumentCategoryLabel.get(DocumentCategoryEnum.MARRIAGE_CERTIFICATE)} é obrigatório`);
        return false;
      }
    }

    if (needMariagePrenuptialAgreement(trade)) {
      const document = await documentService.getDocumentByTradeAndCategory(trade.id, DocumentCategoryEnum.MARRIAGE_PRENUPTIAL_AGREEMENT);

      if (!document) {
        ShowNotification.Error("Não é possivel avançar o trade", `${DocumentCategoryLabel.get(DocumentCategoryEnum.MARRIAGE_PRENUPTIAL_AGREEMENT)} é obrigatório`);
        return false;
      }
    }

    const addressDocument = await documentService.getDocumentByTradeAndCategory(trade.id, DocumentCategoryEnum.PROOF_OF_RESIDENCE);

    if (!addressDocument) {
      ShowNotification.Error("Não é possivel avançar o trade", `${DocumentCategoryLabel.get(DocumentCategoryEnum.PROOF_OF_RESIDENCE)} é obrigatório`);
      return false;
    }

    return true;
  }


  return (
    <Form>
      <div className="contract-info steps-container" style={{ width: "100%" }}>
        <h1>Dados do Cliente</h1>
        <Row style={{ margin: "0 auto  30px", fontWeight: "normal", fontSize: "15px", textTransform: "uppercase" }}>
          <Col xs={8} sm={8} md={8} lg={8}>
            <span style={{ fontWeight: "bold" }}>1 - Dados pessoais</span>
          </Col>
          <Col xs={8} sm={8} md={8} lg={8}>
            <span style={{ color: "lightgrey" }}>2 - Dados bancários</span>
          </Col>
        </Row>
        <p>Agora você deve algumas informações básicas do cliente para seguirmos com o contrato.</p>
        <div className="form-container">
          <Spin spinning={loading} tip="Carregando">
            <TradeEditView
              loading={loading}
              setLoading={setLoading}
              trade={trade}
              setTrade={setTrade}
              form={props.form}
              showBankInfo={false}
              isMotherNameRequired
              isCivilStatusRequired
              isProfessionRequired
              isTradeSpouseRequired
            />
          </Spin>
          <Row className="actions-btn-row" type="flex" justify="center">
            <Col sm={24} xs={24} md={24} lg={24} xl={12}>
              <StandardButton onClick={() => handleSubmit()} loading={loading}>
                Continuar
              </StandardButton>
            </Col>
          </Row>
        </div>
      </div>
    </Form>

  );
}

export default withRouter(Form.create()(ContractInfo));



// WEBPACK FOOTER //
// ./src/pages/step-flow/steps/contract-info/ContractInfo.tsx